/* THE HOME TEAM — Theme JS */
(function() {
  'use strict';

  /* ── Scroll Reveal ───────────────────────────────────── */
  function initScrollReveal() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ── Header scroll state ─────────────────────────────── */
  function initHeader() {
    var header = document.querySelector('.tht-header');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Nav ──────────────────────────────────────── */
  function initMobileNav() {
    var toggle = document.querySelector('.tht-menu-toggle');
    var nav = document.querySelector('.tht-mobile-nav');
    var close = document.querySelector('.tht-mobile-nav__close');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function() { nav.classList.add('open'); });
    if (close) close.addEventListener('click', function() { nav.classList.remove('open'); });
    nav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() { nav.classList.remove('open'); });
    });
  }

  /* ── Product Gallery ─────────────────────────────────── */
  function initGallery() {
    var mainImg = document.querySelector('.tht-gallery__main-img');
    var thumbs = document.querySelectorAll('.tht-gallery__thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Upgrade the thumbnail URL from 200x to 1200x to avoid blurry main image
        var fullSrc = thumb.src
          .replace(/_200x\./,  '_1200x.')
          .replace(/_200x@/,   '_1200x@')
          .replace(/\/200x\./,  '/1200x.')
          .replace(/\?width=200/, '?width=1200');
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = fullSrc;
          mainImg.style.opacity = '1';
        }, 200);
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ── Sticky ATC ──────────────────────────────────────── */
  function initStickyATC() {
    var atcBtn = document.querySelector('.tht-atc-btn');
    var stickyBar = document.querySelector('.tht-sticky-atc');
    if (!atcBtn || !stickyBar) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(atcBtn);
  }

  /* ── Toast ───────────────────────────────────────────── */
  window.thtToast = function(message) {
    var existing = document.querySelector('.tht-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'tht-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.classList.add('show');
      });
    });
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 400);
    }, 3000);
  };

  /* ── Marquee duplicate ───────────────────────────────── */
  function initMarquee() {
    var track = document.querySelector('.tht-marquee__track');
    if (!track) return;
    // Already triplicated in Liquid, just ensure animation runs
  }

  /* ── Init ────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initHeader();
    initMobileNav();
    initGallery();
    initStickyATC();
    initMarquee();
  });

})();
